import React from "react";
import { useLocation } from "react-router-dom";
import minecraftUrls from "../../../../configs/mine_craft/minecraftUrls";

import PageHeader from "../../../../componets/PageHeader";
import NavBarTwo from "../../../../componets/NavBarTwo";

const _PageHeader: React.FC = () => {
  const ITEMS: {[index: number]: any} = {
    1: {
      id: 1,
      name: 'Trending',
      url: minecraftUrls.addonsTrendingPath()
    },
    2: {
      id: 2,
      name: 'Popular',
      url: minecraftUrls.addonsPopularPath()
    },
    3: {
      id: 3,
      name: 'Recents',
      url: minecraftUrls.addonsRecentsPath()
    },
    4: {
      id: 4,
      name: 'Unpublished',
      url: minecraftUrls.addonsUnpublishedPath()
    }
  };

  const { pathname } = useLocation();
  const activeItem = Object.values(ITEMS).find(e => e.url === pathname);

  return (
    <PageHeader
      title={'Community'}
      breadcrumbs={[activeItem?.name]}
    >
      <NavBarTwo
        items={ITEMS}
        itemIds={Object.keys(ITEMS)}
        parent={{
          name: 'All',
          url: minecraftUrls.addonsPath()
        }}
        activeId={activeItem?.id}
      />
    </PageHeader>
  );
}

export default _PageHeader;
